<template>
    <FilterAccordion
        :panel-id="panelId"
        :title="priceFilter.title"
        :expanded="isActive"
        :is-active="isActive"
    >
        <div class="shop-filter-price-row">
            <div class="shop-filter-field">
                <label class="shop-filter-label">{{ $trans('main2.From') }}</label>
                <input
                    v-model.number="minValue"
                    type="number"
                    min="0"
                    :placeholder="$trans('main2.From')"
                    class="shop-filter-input"
                >
            </div>
            <div class="shop-filter-field">
                <label class="shop-filter-label">{{ $trans('main2.To') }}</label>
                <input
                    v-model.number="maxValue"
                    type="number"
                    min="0"
                    :placeholder="$trans('main2.To')"
                    class="shop-filter-input"
                >
            </div>
        </div>
        <div class="shop-filter-actions">
            <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="applyPriceFilter"
            >
                {{ $trans('main.Filter') }}
            </button>
        </div>
    </FilterAccordion>
</template>

<script>
import FilterAccordion from './FilterAccordion.vue';

export default {
    name: 'PriceRangeFilterAccordion',
    components: {FilterAccordion},
    props: {
        priceFilter: {
            type: Object,
            required: true,
        },
        onChangeHandler: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            minValue: undefined,
            maxValue: undefined,
        };
    },
    computed: {
        panelId() {
            return `filter-price-${this.priceFilter.id}`;
        },
        minKey() {
            return this.priceFilter.source === 'listing'
                ? 'min_price'
                : `additional_data_min[${this.priceFilter.slug}]`;
        },
        maxKey() {
            return this.priceFilter.source === 'listing'
                ? 'max_price'
                : `additional_data_max[${this.priceFilter.slug}]`;
        },
        isActive() {
            const filters = this.selectedFilters;

            return filters[this.minKey] !== undefined && filters[this.minKey] !== ''
                || filters[this.maxKey] !== undefined && filters[this.maxKey] !== '';
        },
    },
    mounted() {
        this.syncFromUrl();
    },
    watch: {
        priceFilter() {
            this.syncFromUrl();
        },
    },
    methods: {
        syncFromUrl() {
            const filters = this.selectedFilters;
            this.minValue = this.readNumericFilter(filters[this.minKey]);
            this.maxValue = this.readNumericFilter(filters[this.maxKey]);
        },
        readNumericFilter(value) {
            if (value === undefined || value === null || value === '') {
                return undefined;
            }

            const parsed = Number(value);

            if (Number.isNaN(parsed) || this.isLegacySentinelValue(parsed)) {
                return undefined;
            }

            return parsed;
        },
        isLegacySentinelValue(value) {
            return Number(value) >= 9999999;
        },
        applyPriceFilter() {
            this.onChangeHandler(this.minKey, this.normalizeValue(this.minValue), false);
            this.onChangeHandler(this.maxKey, this.normalizeValue(this.maxValue), true);
        },
        normalizeValue(value) {
            if (value === undefined || value === null || value === '') {
                return null;
            }

            return value;
        },
    },
};
</script>
